<template>
  <el-dialog
    title="导入数据"
    :visible.sync="dialogdata"
    width="620px"
    style="text-align: left"
    :close-on-click-modal="false"
    @close="closeDia"
    @open="opendialog"
  >
    <div class="uploadbox">
      <div v-if="isMonth" class="month-data">
        <span class="demonstration">请选择数据月份</span>
        <el-date-picker
          v-model="monthData"
          type="month"
          value-format="timestamp"
          placeholder="选择月"
          @change="changeMonth"
        >
        </el-date-picker>
      </div>
      <el-upload
        class="avatar-uploader"
        name="image"
        :action="uploadUrl"
        :data="uploadExtraData"
        :headers="uploadHeaders"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeUpload"
      >
        <el-button plain v-if="fileForm.file_name" size="medium"
          >重新选择</el-button
        >
        <el-button type="primary" v-else size="medium">选择文件</el-button>
      </el-upload>
      <div class="filebox" v-if="fileForm.file_name">
        <div>
          <span>上传文件：</span>
          <span style="color: #666">{{ fileForm.file_name }}</span>
        </div>
        <div style>
          <span>文件大小：</span>
          <span style="color: #666">{{ fileForm.file_size }}kb</span>
        </div>
        <div>
          <span>成功模板数：</span>
          <span style="color: #666">{{ fileForm.success_row_count }}条</span>
        </div>
        <div v-if="is_total_price">
          <span>成功数总金额：</span>
          <span style="color: #ff514b">{{ fileForm.total_price }}元</span>
        </div>
        <div v-if="fileForm.fail_row_count">
          <span>错误数据：</span>
          <span style="color: #ff514b">{{ fileForm.fail_row_count }}</span>
        </div>
      </div>

      <div class="total-data" v-if="isConfirm && fileForm.file_name">
        <div class="prompt">
          请再次核对，确认数据无误后请选择“确定”按钮导入系统
        </div>
        <el-table :data="totalData" border style="width: 100%">
          <el-table-column
            v-for="item in tableHeader"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'sale_time'">
                {{ scope.row[item.prop] }}
              </div>
              <div v-else>
                {{
                  JSON.stringify(scope.row[item.prop]) === "null"
                    ? ""
                    : scope.row[item.prop]
                }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="msgbox">
        <el-button type="text" style="font-weight: 600" @click="download"
          >下载模板</el-button
        >

        <template v-if="description != ''">
          <div v-html="description" style="color: #999"></div>
        </template>
        <ul v-else style="color: #999">
          <li>请按照模板格式完整填写数据后导入，否则无法导入</li>
          <li>已创建模板无法再次导入</li>
          <li>最大支持1MB的CSV或Excel文件</li>
          <li v-if="isConfirm && confirmType == 1">
            导入的医生数据不能与已导入的医生重复，只能导入新增的医生数据
          </li>
          <li v-else>错误数据可对照文件行数修改数据后重新导入</li>
          <li>导入模板需要时间，请耐心等待</li>
        </ul>
      </div>
    </div>
    <div
      style="text-align: right; padding: 0 20px 20px 0; box-sizing: border-box"
    >
      <el-button type="primary" @click="close" style="width: 92px" size="medium"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import dayjs from "dayjs";
import constant from "../../service/common/constant";
import common from "../../api/common.js";
export default {
  props: {
    isFlag: {
      type: Boolean,
      require: true,
    },
    interfaceName: {
      // 接口名
      type: String,
      require: true,
    },
    paramsObj: {
      // 导入参数
      type: Object,
      default() {
        return {};
      },
    },
    paramsKey: {
      // 导入参数名
      type: String,
      require: true,
    },
    temName: {
      // 模板名
      type: String,
      require: true,
    },
    isMonth: {
      // 是否有月份
      type: Boolean,
      default: false,
    },
    isConfirm: {
      // 是否确认
      type: Boolean,
      default: false,
    },
    confirmType: {
      // 表格返回数据类型 默认对象1{},2数组[]
      type: Number,
      default: 1,
    },
    confirmInterfaceName: {
      // 确认接口名
      type: String,
      default: "",
    },
    tableHeader: {
      // 确认表格头
      type: Array,
      default() {
        return [];
      },
    },
    description: {
      // 文案说明
      type: String,
      default: "",
    },
    is_total_price: {
      // 统计
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogdata: false,
      uploadExtraData: {
        img_type: 6,
        suffix: ".jpg",
      },
      fileForm: {
        file_name: "",
        file_size: "",
        success_row_count: "",
        fail_row_count: "",
        total_price: 0,
      },
      backData: {},
      monthData: "",
      totalData: [],
      loading: null,
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    uploadUrl() {
      if (process.env.NODE_ENV == "development") {
        // 本地开发使用 api 前缀
        return "/api/platform/upload/uploadFile";
      } else {
        return "/platform/upload/uploadFile";
      }
    },
    uploadHeaders: function() {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ["version", "platform"]),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken,
        }
      );
    },
  },
  watch: {
    isFlag() {
      this.dialogdata = true;
    },
  },
  methods: {
    //提交
    close() {
      if (this.isConfirm) {
        this.confirmFn().then((res) => {
          let { code } = res;
          if (code == 0) {
            this.dialogdata = false;
            this.totalData = [];
            this.$emit("refreshList");
          }
        });
      } else {
        this.dialogdata = false;
        this.$emit("refreshList", this.backData);
      }
    },
    // 月份
    changeMonth() {
      let routeQuery = this.$route.query;
      let startTime = dayjs.unix(routeQuery.start_time).startOf("month");
      let currentTime = dayjs().startOf("month");
      let changeTime = dayjs.unix(this.monthData / 1000).startOf("month");
      if (changeTime < startTime || changeTime > currentTime) {
        this.$message.error("当前时间不支持导入,请重新选择");
        this.monthData = "";
      }
    },
    // 二次确认
    confirmFn() {
      return new Promise(async (resolve) => {
        let params = {};
        if (this.confirmType == 2) {
          params = {
            list: this.totalData,
          };
        }
        let res = await common[this.confirmInterfaceName](params);
        resolve(res);
      });
    },
    //上传之前
    beforeUpload(file) {
      if (this.isMonth && this.monthData == "") {
        this.$message.error("请选择月份");
        return false;
      }
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isText && !isTextComputer) {
        this.$message.error("上传文件只能是CSV或Excel文件");
        return false;
      }
      if (!isLt1M) {
        this.$message.error("最大支持1MB的文件!");
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf("."));
      this.uploadExtraData.suffix = suffix;
      this.totalData = [];
      return (isText && isLt1M) || (isTextComputer && isLt1M);
    },
    //上传成功
    handleAvatarSuccess(res, file, fileList) {
      let loading = this.$loading();
      let { code, data } = res;
      if (code === 0) {
        let params = Object.assign({}, this.paramsObj);
        params[this.paramsKey] = data.pic;
        if (this.isMonth) {
          params["month"] = dayjs(this.monthData).format("YYYY-MM");
        }
        common[this.interfaceName](params)
          .then((res) => {
            let { code, data } = res;
            if (code == 0) {
              if (data.status === 1) {
                let str_html = `<div style="word-wrap: break-word;max-height: 600px;overflow-y: scroll;text-align: left;">${
                  data.success_row_count
                }</div>`;
                this.$confirm(str_html, "提示", {
                  confirmButtonText: "确定",
                  showCancelButton: false,
                  dangerouslyUseHTMLString: true,
                  closeOnClickModal: false,
                  closeOnPressEscape: false,
                  customClass: "cus-importExcel-status",
                  type: "error",
                  center: true,
                })
                  .then(() => {
                    loading.close();
                  })
                  .catch(() => {
                    loading.close();
                  });
                loading.close();
                return;
              }
              this.fileForm.file_name = file.name;
              this.fileForm.file_size = (file.size / 1024).toFixed(2);
              this.fileForm.success_row_count = data.success_row_count;
              this.fileForm.fail_row_count = data.fail_row_count;
              if (this.is_total_price) {
                this.fileForm.total_price = data.total_price;
              }
              if (data.code_array) {
                this.backData = data.code_array;
              }
              if (data.total) {
                this.confirmType == 1
                  ? this.totalData.push(data.total)
                  : this.totalData.push(...data.total);
              }
            }
            loading.close();
          })
          .catch((err) => {
            loading.close();
          });
      } else {
        loading.close();
        this.$message.error(res.message);
      }
    },
    //下载处方模板
    download() {
      let host = `${document.location.protocol}//${
        window.location.host
      }/upload/${this.temName}.xls`;
      location.href = host;
    },
    opendialog() {
      for (let key in this.fileForm) {
        this.fileForm[key] = "";
      }
    },
    closeDia() {
      this.monthData = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.uploadbox {
  padding: 30px 40px;
  box-sizing: border-box;
  .month-data {
    margin-bottom: 10px;
    .demonstration {
      margin-right: 10px;
    }
  }
}
.filebox {
  line-height: 32px;
}
.total-data {
  .prompt {
    font-size: 12px;
    text-align: left;
    color: red;
    padding-left: 10px;
    margin-bottom: 10px;
  }
}
</style>

<style>
.cus-importExcel-status {
  width: 500px !important;
}
</style>
